import { InfoOutlined } from '@mui/icons-material';
import { Alert, AlertColor } from '@mui/material';
import { Text } from '@vestwell-frontend/ui';

import { FC, ReactNode } from 'react';

export type GiftingAlertMessageProps = {
  children: ReactNode;
  severity: AlertColor;
};

export const GiftingAlertMessage: FC<GiftingAlertMessageProps> = props => {
  return (
    <Alert
      icon={<InfoOutlined fontSize='small' />}
      role='note'
      severity={props.severity}>
      <Text color={props.severity} mb={0} variant='i1'>
        {props.children}
      </Text>
    </Alert>
  );
};
